

import { AlertCircle } from 'lucide-react';
import { Dialog, Box, Typography, Button } from '@mui/material';

export default function PermissionDialoge({ open, onClose, message, title = 'Permission needed', iconColor = '#1976d2' }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" PaperProps={{ sx: { borderRadius: 2 } }}>
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
          <AlertCircle size={36} color={iconColor} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {message}
        </Typography>
        <Button variant="contained" onClick={onClose}>OK</Button>
      </Box>
    </Dialog>
  );
}